function getPostsFromQuery(posts) {
  const { nodes } = posts;

  return nodes.map((post) => {
    const frontMatter = post.content ? post.content.frontmatter : post.frontmatter;
    const { title, slug, image, categories, tags } = frontMatter;

    return {
      categories,
      image,
      slug,
      tags,
      title,
    };
  });
}

export default getPostsFromQuery;
